import script from "./AffiliationsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AffiliationsView.vue?vue&type=script&setup=true&lang=ts"

import "./AffiliationsView.vue?vue&type=style&index=0&id=b2706046&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2706046"]])

export default __exports__